
'use strict';
import React, { Component } from 'react';
import ReactDom from 'react-dom';

import {View, Text, TouchableOpacity, Keyboard, ScrollView, Image} from 'react-native';
import {QLinearGradient} from 'qunar-react-native';

import {autorun} from 'mobx';
import { observer, inject } from 'mobx-react';

import styles from './style';
import QImageSet from '../../../../assets/QImageSet'
import {getScreenSize} from "../../../../common/utils";
import { getQueryParam } from "../../../../models/search/util";

@inject(stores => {
    const {lowPriceDataStore} = stores,
        {lowPriceData, setAnchor, anchor} = lowPriceDataStore;

    return {
        tab: lowPriceData && lowPriceData.items && lowPriceData.items.map((item) => {
            return {
                title: item.title,
                anchor: item.title,
            }
        }),
        anchor: anchor,
        setAnchor: setAnchor,
        lowPriceData: lowPriceData
    };
})

@observer
class Tab extends Component {
    constructor(props) {
        super(props);
        this.tabXMap = {};
        this.tabMap  = {};
        this.tabRef = [];
        autorun(() => {
            let curLayout = this.tabXMap[this.props.anchor] || {};
            this.tabScrollRef && this.tabScrollRef.scrollTo({x:curLayout.x + curLayout.width /2 - getScreenSize().width /2})
        })
    }

    componentWillUpdate(){
        this.tabRef = [];
    }

    componentDidUpdate(){
        let {tab, anchor, lowPriceData} = this.props || {};
        this.tabMap = this.transformListToMap(lowPriceData);
        if(this.props.tabFix && tab && this.tabRef.filter((item) => {return ReactDom.findDOMNode(item) !== null}).length === tab.length) {
            this.tabRef.forEach((e, index) => {
                let dom = ReactDom.findDOMNode(e);
                if(dom) {
                    this.tabXMap[tab[index].anchor] = {
                        x: dom.offsetLeft,
                        width: dom.offsetWidth
                    };
                }
            });
        }
        let curLayout = this.tabXMap[this.props.anchor] || {};
        this.tabScrollRef && this.tabScrollRef.scrollTo({x:curLayout.x + curLayout.width /2 - getScreenSize().width /2})
        GodEye.log({
            r: 'scroll_tab_changed',
            cat: getQueryParam('cat') + '_' + this.tabMap[anchor] || ''
        });
    }

    transformListToMap(list) {
        const result = {};
        const items = (list && list.items) ? list.items : []
        for (const item of items) {
            result[item.title] = item.titleCat;
        }
        return result;
    }

    render() {
        let {tab, tabFix, hide} = this.props;
        if(!tab || !tab.length || hide) {
            return <View />
        }

        return (
            <View style={[styles.tabWrapper, tabFix ? styles.tabFixed: {}]}>
                {tabFix
                    ? <View style={styles.tabFixedWrapper}>
                        <Image
                            style={styles.tabShadowImage}
                            source={{uri: QImageSet.tabShadow}}
                            resizeMode={'stretch'}
                        />
                    </View>
                    : <View style={styles.tabShadow}>
                        <QLinearGradient
                            style={styles.tabShadow}
                            colors={['rgba(255,255,255, 0)', '#fff']}
                            end={{x: 0.0, y: 0.0}}
                            start={{x: 0.0, y: 0.3}}
                        />
                    </View>
                }

                <View style={styles.tabScrollWrapper}>
                   <View style={styles.tabHeight}>
                       <ScrollView
                           ref={(e)=>{this.tabScrollRef = e}}
                           style={[styles.tabContainer, tabFix ? styles.tabContainerFixed: {}]}
                           horizontal={true}
                       >
                           {
                               tab.map((item, i) => {
                                   let select = this.props.anchor ? item.anchor === this.props.anchor : i === 0;
                                   return (
                                       <TouchableOpacity
                                           ref={(e)=>{this.tabRef[i] = e}}
                                           style={styles.tabItem}
                                           key={item.title}
                                           onPress={() => {this.props.onTabPress(item.anchor, this.props.type);}}
                                       >
                                           {select ? <View style={styles.tabItemActiveBlock}/> : null}
                                           <Text style={[styles.tabItemTitle, select ? styles.activeTabItem : {}]}>
                                               {item.title}
                                           </Text>
                                       </TouchableOpacity>
                                   )
                               })
                           }
                           <View style={styles.blankBlock}/>
                       </ScrollView>
                   </View>
                </View>
            </View>
        )
    }
}

export default Tab;
